var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-mr",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cd2a3e",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006233",
    d: "M0 72h640v336H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc400",
    d: "M470 154.6a150 150 0 0 1-300 0 154.9 154.9 0 0 0-5 39.2 155 155 0 1 0 310 0 154.4 154.4 0 0 0-5-39.2z",
    className: "st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc400",
    d: "m320 93.8-13.5 41.5H263l35.3 25.6-13.5 41.4 35.3-25.6 35.3 25.6-13.5-41.4 35.3-25.6h-43.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/mr.b54c9b3dd9d9bd0d450edfb3ed16c521.svg";
export { ForwardRef as ReactComponent };